module.exports = __webpack_public_path__ + "img/signup-guide-05-05.dc709086.png";